module.exports = __webpack_public_path__ + "static/media/m_beard_stubble_v_black.3fec9e0f.png";